export default __webpack_public_path__ + "static/media/Group 10893.68d9f908.svg";